import { CanActivateFn, Router } from '@angular/router';
import { UserStateService } from './services/user-state-service';
import { inject } from '@angular/core';

export const loginKassenzeichenGuard: CanActivateFn = (route, state) => {
  const userStateService = inject(UserStateService);
  console.debug('loginKassenzeichenGuard: Checking access to route:', state.url);
  if (!userStateService.isKassenzeichenValid()) {
    inject(Router).navigate(['/']);
    return false; // User is not logged in, prevent access to the route
  }
  return true;
};

export const loginZaehlernummerGuard: CanActivateFn = (route, state) => {
  const userStateService = inject(UserStateService);
  console.debug('loginZaehlernummerGuard: Checking access to route:', state.url);
  if (!userStateService.isZaehlernummerValid()) {
    inject(Router).navigate(['/']);
    return false; // User is not logged in, prevent access to the route
  }
  return true;
};

export const loginGuardGuard: CanActivateFn = (route, state) => {
  const userStateService = inject(UserStateService);
  console.debug('loginGuardGuard: Checking access to route:', state.url);
  if (!userStateService.isLoggedIn()) {
    inject(Router).navigate(['/']);
    return false; // User is not logged in, prevent access to the route
  }
  return true;
};
